import { useAppStore } from '@runtime/core/store/appStore'
import { useEffect, useRef } from 'react'

export function useRailProfileFocus(closeRail: () => void) {
  const profileOpen = useAppStore(state => state.ui.loginOpen)
  const wasOpen = useRef(profileOpen)
  const returnTarget = useRef<HTMLElement | null>(null)

  useEffect(() => {
    if (wasOpen.current && !profileOpen) {
      returnTarget.current?.focus({ preventScroll: true })
      returnTarget.current = null
    }
    wasOpen.current = profileOpen
  }, [profileOpen])

  return () => {
    closeRail()
    returnTarget.current =
      document.activeElement instanceof HTMLElement ? document.activeElement : null
  }
}
